import { commonRequest } from "../../../../services/ApiCall";
import { Helpers } from "../../../../services/Helpers";



export const ChargesServices = {
    addUpdateChargeDetails: async(data)=>{
        return await commonRequest("POST", `${Helpers.URL()}/api/admin/setting/add-update/charge-details`, data, Helpers.token());
    },
    fetchChargeDetails : async(data)=>{
        return await commonRequest('GET',`${Helpers.URL()}/api/admin/setting/charge-details`,{},Helpers.token());
    },
}